import { __ } from '@wordpress/i18n';

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;
const uploadIcon = `${EASYCOMMERCE.assets}admin/img/icons/upload-icon.png`;

const Business = ({ formValues, setFormValues }) => {

    const { business_type: businessTypes, countries } = EASYCOMMERCE;

    const openMediaLibrary = () => {
        const frame = wp.media({
            title: "Select Image",
            button: { text: "Use selected Image" },
            multiple: false,
        });

        frame.on("open", () => {
            const selection = frame.state().get("selection");
            const attachment = wp.media.attachment(formValues.logo?.id);
            attachment.fetch();
            selection.add(attachment);
        });

        frame.on("select", () => {
            const [selected] = frame.state().get("selection").toJSON();
            if (selected?.url) {
                setFormValues(prev => ({
                    ...prev,
                    logo: selected.url
                }));
            }
        });
        
        frame.open();
    };

    const handleChange = (field) => (e) =>
        setFormValues({ ...formValues, [field]: e.target.value });

    const renderSelect = (id, name, label, value, options) => (
        <div className="flex flex-col space-y-2">
            <label htmlFor={id} className="text-ec-body text-[16px] font-medium">
                {label}
            </label>
            <select
                id={id}
                name={name}
                className="easycommerce-wizard-input w-full"
                value={value}
                onChange={handleChange(id)}
            >
                {Object.entries(options).map(([val, text]) => (
                    <option key={val} value={val}>
                        {text}
                    </option>
                ))}
            </select>
        </div>
    );

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
        >
            <h2 className='text-2xl font-inter text-ec-title font-medium mb-8'>{__('Brand Setup', 'easycommerce')}</h2>
            <div className="w-full">
                <div className="flex flex-col w-full space-y-6">

                    {/* Business Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="store_name" className="text-ec-body text-[16px] font-medium">
                            {__('Store Name', 'easycommerce')}
                        </label>
                        <input
                            id="store_name"
                            type="text"
                            name="general-business-store_name"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Write your business name"
                            value={formValues.store_name}
                            onChange={(e) =>
                                setFormValues((prev) => ({ ...prev, store_name: e.target.value }))
                            }
                        />
                    </div>

                    {/* Business Type */}
                    {renderSelect(
                        "business_type",
                        "general-business-business_type",
                        "Business Type",
                        formValues.business_type,
                        businessTypes
                    )}

                    {/* Logo Upload */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">Logo</label>
                        <div className="flex flex-col items-center border-2 border-dashed border-ec-primary rounded-xl py-9 px-6 bg-[#F5F3FF]">
                            {formValues.logo ? (
                                <img
                                    src={formValues.logo}
                                    alt="logo"
                                    onClick={openMediaLibrary}
                                    className="max-h-40 object-fill cursor-pointer hover:opacity-70"
                                />
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26" fill="none">
                                        <path d="M24.0638 20.7716C24.0638 21.6569 23.3389 22.3817 22.4536 22.3817H5.54721C4.66195 22.3817 3.93707 21.6569 3.93707 20.7716V14.8938H0.716797V20.7716C0.716797 23.429 2.88984 25.602 5.54721 25.602H22.4536C25.111 25.602 27.284 23.429 27.284 20.7716V14.8938H24.0638V20.7716Z" fill="#7351FD" fill-opacity="0.5"/>
                                        <path d="M17.2213 17.4301V8.37311H22.3742L14.001 0L5.62793 8.37311H10.7808V17.4301H17.2213Z" fill="#7351FD" fill-opacity="0.5"/>
                                    </svg>

                                    <p className="text-ec-placeholder text-[16px] leading-[26px] mt-1 mb-4">
                                        Click to upload your store logo
                                    </p>
                                    <button
                                        type="button"
                                        onClick={openMediaLibrary}
                                        className="flex justify-center items-center gap-2 font-inter bg-transparent group border border-ec-primary py-[11px] px-4 rounded-lg text-ec-primary hover:text-white hover:bg-ec-primary focus:shadow-none focus:text-white focus:bg-ec-secondary lg:text-sm transition-all ease-in-out duration-500"
                                    >
                                        Upload Logo
                                    </button>
                                </>
                            )}
                            <input type="hidden" name="general-business-logo" value={formValues.logo} />
                        </div>
                    </div>

                    

                    {/* Business Address */}
                    {renderSelect(
                        "country",
                        "general-business-country",
                        "Business Country",
                        formValues.country,
                        countries
                    )}

                    {/* Email */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="email" className="text-ec-body text-[16px] font-medium">
                            Business Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            name="general-business-business_email"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Write your business email"
                            value={formValues.email}
                            onChange={(e) =>
                                setFormValues((prev) => ({ ...prev, email: e.target.value }))
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Business;
